import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureAttribution } from '../../utils/inflowAttribution';

/**
 * 마케팅 유입경로 수집 리스너 (렌더링 없음)
 * - BrowserRouter 내부에 마운트되어 진입/이동 시 utm/referrer를 localStorage에 보존
 * - 관리자 페이지(/admin)는 수집 대상에서 제외
 * - captureAttribution이 멱등이라 StrictMode 2회 실행에도 안전
 */
export default function InflowTracker() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    captureAttribution(
      location.search,
      document.referrer,
      location.pathname,
      window.location.hostname,
    );
  }, [location.search, location.pathname]);

  return null;
}
